// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var TicketActivity$ReactHooksTemplate = require("./ticketActivity.res.js");
var TicketParkView$ReactHooksTemplate = require("./TicketParkView.res.js");
var TicketCloseView$ReactHooksTemplate = require("./TicketCloseView.res.js");
var TicketAssignView$ReactHooksTemplate = require("./TicketAssignView.res.js");
var TicketReopenView$ReactHooksTemplate = require("./TicketReopenView.res.js");
var TicketCommentView$ReactHooksTemplate = require("./TicketCommentView.res.js");
var TicketResolveView$ReactHooksTemplate = require("./TicketResolveView.res.js");

function TicketActivityView(props) {
  var activity = props.activity;
  var match = TicketActivity$ReactHooksTemplate.activityDetails(activity);
  var match$1;
  switch (match.TAG) {
    case "TicketClose" :
        match$1 = [
          Image$ReactHooksTemplate.submit,
          "bg-red-50 border-red-200",
          "Closed",
          "text-red-700"
        ];
        break;
    case "TicketAssign" :
        match$1 = [
          Image$ReactHooksTemplate.userPlus,
          "bg-purple-50 border-purple-200",
          "Assigned",
          "text-purple-700"
        ];
        break;
    case "TicketResolve" :
        match$1 = [
          Image$ReactHooksTemplate.submit,
          "bg-green-50 border-green-200",
          "Resolved",
          "text-green-700"
        ];
        break;
    case "TicketPark" :
        match$1 = [
          Image$ReactHooksTemplate.clockCircle,
          "bg-yellow-50 border-yellow-200",
          "Parked",
          "text-yellow-700"
        ];
        break;
    case "TicketComment" :
        match$1 = [
          Image$ReactHooksTemplate.commentIcon,
          "bg-blue-50 border-blue-200",
          "Comment",
          "text-blue-700"
        ];
        break;
    case "TicketReopen" :
        match$1 = [
          Image$ReactHooksTemplate.curvedArrow,
          "bg-indigo-50 border-indigo-200",
          "Reopened",
          "text-indigo-700"
        ];
        break;
    
  }
  var activity$1 = TicketActivity$ReactHooksTemplate.activityDetails(activity);
  var tmp;
  switch (activity$1.TAG) {
    case "TicketClose" :
        tmp = JsxRuntime.jsx(TicketCloseView$ReactHooksTemplate.make, {
              activity: activity$1._0
            });
        break;
    case "TicketAssign" :
        tmp = JsxRuntime.jsx(TicketAssignView$ReactHooksTemplate.make, {
              activity: activity$1._0
            });
        break;
    case "TicketResolve" :
        tmp = JsxRuntime.jsx(TicketResolveView$ReactHooksTemplate.make, {
              activity: activity$1._0
            });
        break;
    case "TicketPark" :
        tmp = JsxRuntime.jsx(TicketParkView$ReactHooksTemplate.make, {
              activity: activity$1._0
            });
        break;
    case "TicketComment" :
        tmp = JsxRuntime.jsx(TicketCommentView$ReactHooksTemplate.make, {
              activity: activity$1._0
            });
        break;
    case "TicketReopen" :
        tmp = JsxRuntime.jsx(TicketReopenView$ReactHooksTemplate.make, {
              activity: activity$1._0
            });
        break;
    
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("img", {
                            className: "h-3.5 w-3.5",
                            src: match$1[0]
                          }),
                      className: "flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center border " + match$1[1]
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("span", {
                                            children: match$1[2],
                                            className: "text-xs font-semibold " + match$1[3]
                                          }),
                                      JsxRuntime.jsx("span", {
                                            children: "-",
                                            className: "text-gray-400 text-xs"
                                          }),
                                      JsxRuntime.jsx("span", {
                                            children: TicketActivity$ReactHooksTemplate.createdAt(activity).format("MMM DD, h:mm A"),
                                            className: "text-gray-500 text-xs"
                                          })
                                    ],
                                    className: "flex items-center gap-2"
                                  }),
                              className: "flex items-center justify-between mb-1"
                            }),
                        JsxRuntime.jsx("div", {
                              children: tmp
                            })
                      ],
                      className: "flex-1 bg-gray-50 rounded-lg border border-gray-200 p-2"
                    })
              ],
              className: "flex gap-2 w-full"
            });
}

var make = TicketActivityView;

exports.make = make;
/* react/jsx-runtime Not a pure module */
